// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.subscription-item[data-v-5c51982e] {\n  padding: 0.5rem 0;\n}\n.subscription-item[data-v-5c51982e]:hover {\n  margin: 0 -0.5rem;\n  padding: 0.5rem;\n  width: calc(100% + 1rem);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
